import { ReactNode } from "react";

import { clsx } from "clsx";

import styles from "../../ConfigurableVariablesPickerPlugin.module.scss";

import type { ConfigurableVariableOption } from "../../ConfigurableVariableOption";

export function ConfigurableVariableMenuItem({
    isSelected,
    onClick,
    onMouseEnter,
    onMouseMove,
    option,
    renderer,
}: {
    isSelected: boolean;
    onClick: () => void;
    onMouseEnter: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onMouseMove: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    option: ConfigurableVariableOption;
    renderer?: (data: ConfigurableVariableOption) => ReactNode;
}) {
    return (
        <li
            key={option.value}
            tabIndex={-1}
            className={clsx(styles.menuItem, { [styles.selected]: isSelected })}
            ref={option.setRefElement}
            role="option"
            aria-selected={isSelected}
            onMouseEnter={onMouseEnter}
            onMouseMove={onMouseMove}
            onClick={onClick}
        >
            {!!renderer && renderer(option)}
            {!renderer && (
                <>
                    {option.displayText || option.text}
                    {option.dataType && <span className={styles.typeMetaInfo}>Data Type: {option.dataType}</span>}
                </>
            )}
        </li>
    );
}
